/* tslint:disable */
/* eslint-disable */
/**
 * authentik
 * Making authentication simple.
 *
 * The version of the OpenAPI document: 2024.12.3
 * Contact: hello@goauthentik.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 */
export const UiThemeEnum = {
    Automatic: 'automatic',
    Light: 'light',
    Dark: 'dark',
    UnknownDefaultOpenApi: '11184809'
};
export function instanceOfUiThemeEnum(value) {
    for (const key in UiThemeEnum) {
        if (Object.prototype.hasOwnProperty.call(UiThemeEnum, key)) {
            if (UiThemeEnum[key] === value) {
                return true;
            }
        }
    }
    return false;
}
export function UiThemeEnumFromJSON(json) {
    return UiThemeEnumFromJSONTyped(json, false);
}
export function UiThemeEnumFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function UiThemeEnumToJSON(value) {
    return value;
}
export function UiThemeEnumToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
